<div id="app">
  <div class="content-wrapper">
    @if ((Merchant$ | async); as Merchant) {
      @if(showHeader && !hideHeaderForOutletHome){
      <app-header [Home]="Home" [Merchant]="Merchant" [Product]="Product" [Basket]="Basket" [PaymentScreen]="PaymentScreen">
      </app-header>
      }
    }
    <router-outlet></router-outlet>
    @if ((Merchant$ | async); as Merchant) {
      <app-online-status [onlineStatusMessage]="connectionStatusMessage" [Merchant]="Merchant"
        [onlineStatus]="connectionStatus"></app-online-status>
      <app-footer [Home]="Home" [RouetChangeDetect]="RouetChangeDetect" [Merchant]="Merchant"></app-footer>
    }
    <app-loader [showLoader]="showLoader"></app-loader>
    <div class="circonf-wrap" style="display:none" id="loader">
      <div class="circontainer">
        <div class="circonf circonf-1"></div>
        <span class="circonf-text">Payment Processing</span>
      </div>
    </div>
  </div>
</div>